import { render } from "./DefaultComponent.vue?vue&type=template&id=9ddb97b2"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/DefaultComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ddb97b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ddb97b2', __exports__)) {
    api.reload('9ddb97b2', __exports__)
  }
  
  module.hot.accept("./DefaultComponent.vue?vue&type=template&id=9ddb97b2", () => {
    api.rerender('9ddb97b2', render)
  })

}


export default __exports__